import React from "react"
import { makeAutoObservable } from "mobx"
import camelcaseKeys from "camelcase-keys"

import { createLoadingKeys } from "src/lib/loading"
import { Pagination } from "src/lib/pagination"
import { ProductCatalogueAdminService } from "src/api"
import { DEFAULT_ACCESS_GROUP } from "src/config"
import { parseDate } from "src/lib/date"

export class OrdersStore {
    static Context = React.createContext<OrdersStore | null>(null)
    static LoadingKeys = createLoadingKeys("pageLoad")
    private _accessGroupId: number = DEFAULT_ACCESS_GROUP.id

    orders = new Pagination(
        async (query) => {
            const response =
                await ProductCatalogueAdminService.getV1AdminCatalogueOrder({
                    pageNumber: query.page,
                    pageSize: query.pageSize,
                    accessGroupId: this.getAccountGroupId(),
                })

            const items =
                response.orders?.map((order) => ({
                    ...camelcaseKeys(order),
                    id: order.order_id as number,
                    orderDate:
                        order.order_date != null
                            ? parseDate(order.order_date)
                            : undefined,
                })) ?? []

            return {
                items: items,
                count: response.total_count ?? items?.length ?? 0,
            }
        },
        {
            loadingKey: OrdersStore.LoadingKeys.pageLoad,
        },
    )

    constructor() {
        makeAutoObservable(this)
    }

    async init() {
        await this.orders.loadInitialPage()
    }

    private getAccountGroupId() {
        return this._accessGroupId !== DEFAULT_ACCESS_GROUP.id
            ? this._accessGroupId
            : undefined
    }
}

export interface IOrder {
    adminName?: string
    currency?: string
    orderDate?: Date
    orderId?: number
    priceCents?: number
    provider?: string
    status?: string
    tenantId?: number
}
